import { appAlertCircleIcon } from './alert-circle';
import { appAlertOctagonIcon } from './alert-octagon';
import { appAlertTriangleIcon } from './alert-triangle';
import { appBell04Icon } from './bell-04';
import { appBellRinging04Icon } from './bell-ringing-04';
import { appNotificationMessageIcon } from './notification-message';
import { appThumbsUpIcon } from './thumbs-up';
export const alertsIcons = [appAlertCircleIcon, appAlertOctagonIcon, appAlertTriangleIcon, appBell04Icon, appBellRinging04Icon, appNotificationMessageIcon, appThumbsUpIcon];
